import React from 'react';
import { motion } from 'framer-motion';
import { useAnimateLevel } from '../../../handler/use-animate-level';

export function Level() {
  const { displayed_level_value, is_changing_value, change_direction_value } =
    useAnimateLevel();

  const get_animation_colors = () => {
    if (change_direction_value === 'up')
      return ['#FFFFFF', '#FECF3A', '#FFFFFF'];
    if (change_direction_value === 'down')
      return ['#FFFFFF', '#FF0000', '#FFFFFF'];
    return '#FFFFFF';
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-1">
      <span className="text-white text-lg">Level</span>
      <motion.span
        className="text-white font-bold text-7xl"
        animate={{
          scale: is_changing_value ? [1, 1.2, 1] : 1,
          color: is_changing_value ? get_animation_colors() : '#FFFFFF',
        }}
        transition={{
          duration: 0.4,
          ease: 'easeInOut',
        }}
        key={displayed_level_value}
      >
        {displayed_level_value}
      </motion.span>
    </div>
  );
}

